<template>
  <div>
    <DataTableDeCrud
      :items="atualizacoes"
      :headers="headers"
      :rotina-id="ID_TELA_DE_ATUALIZACOES"
      :configurar="false"
      :remover="false"
      :loading="loading"
      :sort-by="'codigo'"
      @create="() => abrirDialogCriarAtualizacao()"
      @update="(indice) => abrirDialogEditarAtualizacao(indice)"
    >
      <template #[`item.entradaSaida`]="{ item }">
        <v-btn
          color="primary"
          small
          outlined
          :to="{
            name: 'TelaDeEntradas',
            params: {
              atualizacao: item
            }
          }"
        >
          Entradas
        </v-btn>
        <v-btn
          color="primary"
          small
          class="ml-1"
          outlined
          :to="{
            name: 'TelaDeSaidas',
            params: {
              atualizacao: item
            }
          }"
        >
          Saídas
        </v-btn>
      </template>

      <template #[`item.periodo`]="{ item }">
        {{ formatDate(item.dataInicio) }} - {{ formatDate(item.dataFim) }}
      </template>
    </DataTableDeCrud>

    <DialogDeEdicaoDeAtualizacao
      :operacao="operacao"
      :show-dialog.sync="showDialogEdicaoParam"
      :atualizacao-param="atualizacaoParam"
      :itens="itensParam"
      @confirmado="atualizarAtualizacao"
    />

    <DialogDeCriacaoDeAtualizacao
      :show-dialog.sync="showDialogCriacaoParam"
      :itens="itensParam"
      @confirmado="atualizarAtualizacao"
    />

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />
  </div>
</template>

<script>
import AtualizacaoService from '@/services/atualizacao/atualizacao'
import EmpresaService from '@/services/empresa/empresa'
import DataTableDeCrud from '@/components/DataTableDeCrud.vue'
import SnackbarMessage from '@/components/SnackbarMessage'
import DialogDeEdicaoDeAtualizacao from '@/components/atualizacoes/DialogDeEdicaoDeAtualizacao'
import DialogDeCriacaoDeAtualizacao from '@/components/atualizacoes/DialogDeCriacaoDeAtualizacao'
import SnackBar from '@/models/components/snackbar'
import Atualizacao from '@/models/atualizacao'
import { ID_TELA_DE_ATUALIZACOES } from '@/common/constants'
import { formataCpfCnpj, formatDate } from '@/shareds/formatacoes'

export default {
  components: {
    DataTableDeCrud,
    SnackbarMessage,
    DialogDeEdicaoDeAtualizacao,
    DialogDeCriacaoDeAtualizacao
  },

  data: () => ({
    atualizacoes: [],
    headers: [
      { text: 'Empresa', value: 'empresa.nome' },
      { text: 'Código', value: 'codigo' },
      { text: 'Período', value: 'periodo' },
      { text: 'Leitor', value: 'tipoLeitor' },
      { text: 'Usuário', value: 'usuario.nome' },
      { text: 'Status', value: 'status' },
      { text: '', value: 'entradaSaida', width: 250, sortable: false }
    ],
    loading: false,
    operacao: '',
    showDialogEdicaoParam: false,
    showDialogCriacaoParam: false,
    atualizacaoParam: new Atualizacao(),
    itensParam: {},
    snackbar: new SnackBar(),
    ID_TELA_DE_ATUALIZACOES: ID_TELA_DE_ATUALIZACOES,
    formatDate: formatDate
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        this.loadAtualizacoes()
        this.loadEmpresas()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar PISCOFINS cadastrados.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadAtualizacoes() {
      this.loading = true
      this.atualizacoes = await AtualizacaoService.getAll()
      this.loading = false
    },

    async loadEmpresas() {
      this.loading = true
      const response = await EmpresaService.getAll()
      this.itensEmpresa = response.map((empresa) => ({
        text: empresa.nome + ' - ' + formataCpfCnpj(empresa.documento),
        value: empresa.id
      }))
      this.loading = false
    },

    abrirDialogCriarAtualizacao() {
      this.itensParam = { empresa: this.itensEmpresa }
      this.showDialogCriacaoParam = true
    },

    abrirDialogEditarAtualizacao(indice) {
      this.operacao = 'editar'
      this.atualizacaoParam = { ...this.atualizacoes[indice] }
      this.showDialogEdicaoParam = true
    },

    atualizarAtualizacao(atualizacao) {
      if (!atualizacao) return

      const indice = this.atualizacoes.findIndex(
        (atualizacaoExistente) => atualizacaoExistente.id === atualizacao.id
      )

      if (indice === -1) {
        this.atualizacoes.push(atualizacao)
        this.snackbar.snackTextParam = 'Atualização criado com sucesso.'
      } else {
        this.atualizacoes.splice(indice, 1, atualizacao)
        this.snackbar.snackTextParam = 'Atualização atualizada com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    }
  }
}
</script>

<style></style>
